
// export class contractHelper {

//     vestingContractAddress = "0xB02C238dBcA61c3e91BfcF37cA1097a42560d485";
//     nodeContractDeployRpcUrl = "https://rpc2.fieroscan.com/";
//     vestingAbi = [
//         {
//             "inputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "_adminComm",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "nonpayable",
//             "type": "ructor"
//         },
//         {
//             "anonymous": false,
//             "inputs": [
//                 {
//                     "indexed": true,
//                     "internalType": "address",
//                     "name": "previousOwner",
//                     "type": "address"
//                 },
//                 {
//                     "indexed": true,
//                     "internalType": "address",
//                     "name": "newOwner",
//                     "type": "address"
//                 }
//             ],
//             "name": "OwnershipTransferred",
//             "type": "event"
//         },
//         {
//             "anonymous": false,
//             "inputs": [
//                 {
//                     "indexed": false,
//                     "internalType": "uint256",
//                     "name": "amount",
//                     "type": "uint256"
//                 },
//                 {
//                     "indexed": false,
//                     "internalType": "uint256",
//                     "name": "timestamp",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "Withdraw",
//             "type": "event"
//         },
//         {
//             "inputs": [],
//             "name": "adminComm",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 }
//             ],
//             "name": "allocateForVesting",
//             "outputs": [],
//             "stateMutability": "payable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "",
//                     "type": "address"
//                 }
//             ],
//             "name": "allocatedUser",
//             "outputs": [
//                 {
//                     "internalType": "bool",
//                     "name": "",
//                     "type": "bool"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "claimTokens",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "claimTotalTokens",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "_amount",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "drainTokens",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_wallet",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "getUnlockedTokenAmount",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 }
//             ],
//             "name": "getUserTotalVesting",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "getVestingInfo",
//             "outputs": [
//                 {
//                     "components": [
//                         {
//                             "internalType": "uint256",
//                             "name": "allocatedAmount",
//                             "type": "uint256"
//                         },
//                         {
//                             "internalType": "uint256",
//                             "name": "claimedAmount",
//                             "type": "uint256"
//                         },
//                         {
//                             "internalType": "uint256",
//                             "name": "nextClaimTimestamp",
//                             "type": "uint256"
//                         },
//                         {
//                             "internalType": "uint256",
//                             "name": "claimEndTimestamp",
//                             "type": "uint256"
//                         }
//                     ],
//                     "internalType": "struct Vesting.VestingInfo",
//                     "name": "",
//                     "type": "tuple"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [],
//             "name": "owner",
//             "outputs": [
//                 {
//                     "internalType": "address",
//                     "name": "",
//                     "type": "address"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [],
//             "name": "renounceOwnership",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "newOwner",
//                     "type": "address"
//                 }
//             ],
//             "name": "transferOwnership",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "_adminComm",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "updateAdminCommission",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "",
//                     "type": "address"
//                 }
//             ],
//             "name": "userInfo",
//             "outputs": [
//                 {
//                     "internalType": "address",
//                     "name": "wallet",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "totalAllocatedAmount",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "totalClaimedAmount",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         }
//     ]
//     nodeContractDeployAbi = [
//         {
//             "inputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "_adminComm",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_vestingEndDay",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_claimEndDay",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "nonpayable",
//             "type": "ructor"
//         },
//         {
//             "anonymous": false,
//             "inputs": [
//                 {
//                     "indexed": true,
//                     "internalType": "address",
//                     "name": "previousOwner",
//                     "type": "address"
//                 },
//                 {
//                     "indexed": true,
//                     "internalType": "address",
//                     "name": "newOwner",
//                     "type": "address"
//                 }
//             ],
//             "name": "OwnershipTransferred",
//             "type": "event"
//         },
//         {
//             "anonymous": false,
//             "inputs": [
//                 {
//                     "indexed": false,
//                     "internalType": "uint256",
//                     "name": "amount",
//                     "type": "uint256"
//                 },
//                 {
//                     "indexed": false,
//                     "internalType": "uint256",
//                     "name": "timestamp",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "Withdraw",
//             "type": "event"
//         },
//         {
//             "inputs": [],
//             "name": "EndDay",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [],
//             "name": "adminComm",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 }
//             ],
//             "name": "allocateForVesting",
//             "outputs": [],
//             "stateMutability": "payable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "",
//                     "type": "address"
//                 }
//             ],
//             "name": "allocatedUser",
//             "outputs": [
//                 {
//                     "internalType": "bool",
//                     "name": "",
//                     "type": "bool"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [],
//             "name": "claimEndDay",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "claimTokens",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "claimTotalTokens",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "_amount",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "drainTokens",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_wallet",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "getUnlockedTokenAmount",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 }
//             ],
//             "name": "getUserTotalVesting",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_id",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "getVestingInfo",
//             "outputs": [
//                 {
//                     "components": [
//                         {
//                             "internalType": "uint256",
//                             "name": "allocatedAmount",
//                             "type": "uint256"
//                         },
//                         {
//                             "internalType": "uint256",
//                             "name": "claimedAmount",
//                             "type": "uint256"
//                         },
//                         {
//                             "internalType": "uint256",
//                             "name": "nextClaimTimestamp",
//                             "type": "uint256"
//                         },
//                         {
//                             "internalType": "uint256",
//                             "name": "claimEndTimestamp",
//                             "type": "uint256"
//                         }
//                     ],
//                     "internalType": "struct Vesting.VestingInfo",
//                     "name": "",
//                     "type": "tuple"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [],
//             "name": "owner",
//             "outputs": [
//                 {
//                     "internalType": "address",
//                     "name": "",
//                     "type": "address"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [],
//             "name": "renounceOwnership",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "newOwner",
//                     "type": "address"
//                 }
//             ],
//             "name": "transferOwnership",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "_adminComm",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "updateAdminCommission",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "_vestingEndDay",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_claimEndDay",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "updateVestingDays",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "_user",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "index",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "_newVestingStartTimestamp",
//                     "type": "uint256"
//                 }
//             ],
//             "name": "updateVestingStartTimestamp",
//             "outputs": [],
//             "stateMutability": "nonpayable",
//             "type": "function"
//         },
//         {
//             "inputs": [
//                 {
//                     "internalType": "address",
//                     "name": "",
//                     "type": "address"
//                 }
//             ],
//             "name": "userInfo",
//             "outputs": [
//                 {
//                     "internalType": "address",
//                     "name": "wallet",
//                     "type": "address"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "totalAllocatedAmount",
//                     "type": "uint256"
//                 },
//                 {
//                     "internalType": "uint256",
//                     "name": "totalClaimedAmount",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         },
//         {
//             "inputs": [],
//             "name": "vestingEndDay",
//             "outputs": [
//                 {
//                     "internalType": "uint256",
//                     "name": "",
//                     "type": "uint256"
//                 }
//             ],
//             "stateMutability": "view",
//             "type": "function"
//         }
//     ];
//     nodeContractMetaData = "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"

// }

export class contractHelper {
    vestingContractAddress = "0xB02C238dBcA61c3e91BfcF37cA1097a42560d485";
    nodeContractDeployRpcUrl = "https://rpc2.fieroscan.com/";
    vestingAbi = [
       {
           "inputs": [
               {
                   "internalType": "uint256",
                   "name": "_adminComm",
                   "type": "uint256"
               }
           ],
           "stateMutability": "nonpayable",
           "type": "ructor"
       },
       {
           "anonymous": false,
           "inputs": [
               {
                   "indexed": true,
                   "internalType": "address",
                   "name": "previousOwner",
                   "type": "address"
               },
               {
                   "indexed": true,
                   "internalType": "address",
                   "name": "newOwner",
                   "type": "address"
               }
           ],
           "name": "OwnershipTransferred",
           "type": "event"
       },
       {
           "anonymous": false,
           "inputs": [
               {
                   "indexed": false,
                   "internalType": "uint256",
                   "name": "amount",
                   "type": "uint256"
               },
               {
                   "indexed": false,
                   "internalType": "uint256",
                   "name": "timestamp",
                   "type": "uint256"
               }
           ],
           "name": "Withdraw",
           "type": "event"
       },
       {
           "inputs": [],
           "name": "adminComm",
           "outputs": [
               {
                   "internalType": "uint256",
                   "name": "",
                   "type": "uint256"
               }
           ],
           "stateMutability": "view",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "_user",
                   "type": "address"
               }
           ],
           "name": "allocateForVesting",
           "outputs": [],
           "stateMutability": "payable",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "",
                   "type": "address"
               }
           ],
           "name": "allocatedUser",
           "outputs": [
               {
                   "internalType": "bool",
                   "name": "",
                   "type": "bool"
               }
           ],
           "stateMutability": "view",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "_user",
                   "type": "address"
               },
               {
                   "internalType": "uint256",
                   "name": "_id",
                   "type": "uint256"
               }
           ],
           "name": "claimTokens",
           "outputs": [],
           "stateMutability": "nonpayable",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "_user",
                   "type": "address"
               },
               {
                   "internalType": "uint256",
                   "name": "_id",
                   "type": "uint256"
               }
           ],
           "name": "claimTotalTokens",
           "outputs": [],
           "stateMutability": "nonpayable",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "uint256",
                   "name": "_amount",
                   "type": "uint256"
               }
           ],
           "name": "drainTokens",
           "outputs": [],
           "stateMutability": "nonpayable",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "_wallet",
                   "type": "address"
               },
               {
                   "internalType": "uint256",
                   "name": "_id",
                   "type": "uint256"
               }
           ],
           "name": "getUnlockedTokenAmount",
           "outputs": [
               {
                   "internalType": "uint256",
                   "name": "",
                   "type": "uint256"
               },
               {
                   "internalType": "uint256",
                   "name": "",
                   "type": "uint256"
               }
           ],
           "stateMutability": "view",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "_user",
                   "type": "address"
               }
           ],
           "name": "getUserTotalVesting",
           "outputs": [
               {
                   "internalType": "uint256",
                   "name": "",
                   "type": "uint256"
               }
           ],
           "stateMutability": "view",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "_user",
                   "type": "address"
               },
               {
                   "internalType": "uint256",
                   "name": "_id",
                   "type": "uint256"
               }
           ],
           "name": "getVestingInfo",
           "outputs": [
               {
                   "components": [
                       {
                           "internalType": "uint256",
                           "name": "allocatedAmount",
                           "type": "uint256"
                       },
                       {
                           "internalType": "uint256",
                           "name": "claimedAmount",
                           "type": "uint256"
                       },
                       {
                           "internalType": "uint256",
                           "name": "nextClaimTimestamp",
                           "type": "uint256"
                       },
                       {
                           "internalType": "uint256",
                           "name": "claimEndTimestamp",
                           "type": "uint256"
                       }
                   ],
                   "internalType": "struct Vesting.VestingInfo",
                   "name": "",
                   "type": "tuple"
               }
           ],
           "stateMutability": "view",
           "type": "function"
       },
       {
           "inputs": [],
           "name": "owner",
           "outputs": [
               {
                   "internalType": "address",
                   "name": "",
                   "type": "address"
               }
           ],
           "stateMutability": "view",
           "type": "function"
       },
       {
           "inputs": [],
           "name": "renounceOwnership",
           "outputs": [],
           "stateMutability": "nonpayable",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "newOwner",
                   "type": "address"
               }
           ],
           "name": "transferOwnership",
           "outputs": [],
           "stateMutability": "nonpayable",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "uint256",
                   "name": "_adminComm",
                   "type": "uint256"
               }
           ],
           "name": "updateAdminCommission",
           "outputs": [],
           "stateMutability": "nonpayable",
           "type": "function"
       },
       {
           "inputs": [
               {
                   "internalType": "address",
                   "name": "",
                   "type": "address"
               }
           ],
           "name": "userInfo",
           "outputs": [
               {
                   "internalType": "address",
                   "name": "wallet",
                   "type": "address"
               },
               {
                   "internalType": "uint256",
                   "name": "totalAllocatedAmount",
                   "type": "uint256"
               },
               {
                   "internalType": "uint256",
                   "name": "totalClaimedAmount",
                   "type": "uint256"
               }
           ],
           "stateMutability": "view",
           "type": "function"
       }
   ];
    nodeContractDeployAbi = [
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "_adminComm",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "_vestingEndDay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "_claimEndDay",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newCommission",
            "type": "uint256"
          }
        ],
        "name": "AdminCommissionUpdated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "previousOwner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "user",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ],
        "name": "TokensClaimed",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "TokensDrained",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "user",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "newUserClaimAddress",
            "type": "address"
          }
        ],
        "name": "UserClaimAddressChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "user",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "userClaimAddress",
            "type": "address"
          }
        ],
        "name": "UserVestingAllocated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newVestingEndDay",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newClaimEndDay",
            "type": "uint256"
          }
        ],
        "name": "VestingDaysUpdated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "user",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "index",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newTimestamp",
            "type": "uint256"
          }
        ],
        "name": "VestingStartTimestampUpdated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ],
        "name": "Withdraw",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "EndDay",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "adminComm",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_user",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "_userClaimAddress",
            "type": "address"
          }
        ],
        "name": "allocateForVesting",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "name": "allocatedUser",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_user",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "_newUserClaimAddress",
            "type": "address"
          }
        ],
        "name": "changeUserClaimAddress",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "claimEndDay",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_user",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "_id",
            "type": "uint256"
          }
        ],
        "name": "claimTokens",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_user",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "_id",
            "type": "uint256"
          }
        ],
        "name": "claimTotalTokens",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "_amount",
            "type": "uint256"
          }
        ],
        "name": "drainTokens",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_wallet",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "_id",
            "type": "uint256"
          }
        ],
        "name": "getUnlockedTokenAmount",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_user",
            "type": "address"
          }
        ],
        "name": "getUserTotalVesting",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_user",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "_id",
            "type": "uint256"
          }
        ],
        "name": "getVestingInfo",
        "outputs": [
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "allocatedAmount",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "claimedAmount",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "nextClaimTimestamp",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "claimEndTimestamp",
                "type": "uint256"
              }
            ],
            "internalType": "struct Vesting.VestingInfo",
            "name": "",
            "type": "tuple"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "owner",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "_adminComm",
            "type": "uint256"
          }
        ],
        "name": "updateAdminCommission",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "_vestingEndDay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "_claimEndDay",
            "type": "uint256"
          }
        ],
        "name": "updateVestingDays",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_user",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "index",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "_newVestingStartTimestamp",
            "type": "uint256"
          }
        ],
        "name": "updateVestingStartTimestamp",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "name": "userInfo",
        "outputs": [
          {
            "internalType": "address",
            "name": "wallet",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "totalAllocatedAmount",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalClaimedAmount",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "userClaimAddress",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "vestingEndDay",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      }
    ];
    nodeContractMetaData = "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"
   
 
}